import "./Home.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import AboutSection from "./sections/AboutSection";
import ServicesGrid from "./sections/ServicesGrid";
import TheNeighborlyAdvantage from "./sections/TheNeighborlyAdvantage";
import PerformanceInsights from "./sections/PerformanceInsights";
import KeyFigures from "./sections/KeyFigures";
import Footer from "@/reusable_sections/Footer";
import OperationalClarityFaq from "./sections/OperationalClarityFaq";
export default function HomePage() {
  return <div>
      <VoltMainHeader />
      <AboutSection />
      <ServicesGrid />
      <TheNeighborlyAdvantage />
      <OperationalClarityFaq />
      <PerformanceInsights />
      <KeyFigures />
      <Footer />
    </div>;
}